<template>
  <div class="row align-items-center">
    <div class="" v-for="(post, index) in posts" :key="index">
        <hr>
        <div class="card-row banner-mobile" v-if="post.promotion">
          <div class="col-12">
            <a :href="`${post.cover.url}`">
              <img :src="`${post.cover.image}`" alt="Banner" width="300" height="250">
            </a>
          </div>
        </div>
        <div class="card-row" v-else>
          <div class="col-5">
            <router-link v-if="post.content_type" :to="{
              name: 'BlogSingle',
              params: { 
                locale: this.locale,
                blogId: post.id,
                blogName: post.slug
              }
            }">            
              <img 
                width="135"
                height="76"
                :src="`${post.cover}`" 
                :alt="post.title"
              >
            </router-link>                        
            <a v-else :href="post.link_redirect">
              <img 
                width="135"
                height="76"
                :src="`${post.cover}`" 
                :alt="post.title"
              >
            </a>    
          </div>            
          <div class="col-7">
            <router-link v-if="post.content_type" :to="{
              name: 'BlogSingle',
              params: { 
                locale: this.locale,
                blogId: post.id,
                blogName: post.slug
              }
            }" class="button--more">
              <div class="card-title">{{ post.title }}</div>
              <p class="card-text mt-2" v-for="description in post.meta_description" :key="description.language_id">
                <span v-if="description.language_id === 1 && locale === 'pt-br'" v-text="description.content"></span>
                <span v-if="description.language_id === 2 && locale === 'en'" v-text="description.content"></span>
              </p>
            </router-link>       
            <a v-else :href="post.link_redirect">
              <div class="card-title">{{ post.title }}</div>
              <p class="card-text mt-2" v-for="description in post.meta_description" :key="description.language_id">
                <span v-if="description.language_id === 1 && locale === 'pt-br'" v-text="description.content"></span>
                <span v-if="description.language_id === 2 && locale === 'en'" v-text="description.content"></span>
              </p>              
            </a>     
          </div>
        </div>
    </div>
    <hr>
    <router-link v-if="home" :to="{
      name: 'BlogsPage',
      params: { locale }
    }" class="button button--o">
      {{ translateMain.goToBlog }}
      <font-awesome-icon :icon="['fas', 'arrow-right']" size="lg" style="margin-left: 10px" />
    </router-link>

  </div>

</template>

<script lang="ts">
import { mapState } from 'pinia'
import { localeStore } from 'stores/locale'
import translateMain from 'tradutors/menu'

export default {
  name: 'PostListItemMobile',
  props: ['posts', 'home'],
  computed: {
    ...mapState(localeStore, ['locale']),
    translateMain: function () {
      if (this.locale === 'pt-br') {
        return translateMain.portugues
      } else {
        return translateMain.ingles
      }
    },
    image() {
      return `${this.$root.baseUrl}/storage/blog/${this.post.cover}`
    },
    findImage(file) {
      return `${this.$root.baseUrl}/storage/blog/${file}`
    }
  },
  methods: {}
}
</script>
<style scoped>
.card-title {
  color: #B20000;
  font-family: 'Roboto-Medium';
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 21px;
  padding: 0 10px;
}

.card-text {
  color: #5b5858;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  padding: 0 10px;
}

.card-text span{
  font-family: 'Roboto-Regular';
}

.button--more svg {
  color: #b20000;
}

.button--more {
  font-family: 'Exo-2';
  font-weight: bold;
}

.small svg {
  margin-right: 5px;
}

.card-row img {
  width: 100%;
  object-fit: cover;
  height: auto;
}

.card-row {
  background-color: var(--bs-white);
  width: 100%;
  display: flex;
  min-height: 170px;
}

.banner-mobile {
  height: unset;
}

.banner-mobile img {
  width: 100%;
  object-fit: cover;
}

hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #AAAAAA;
  margin: 30px 0px;
  padding: 0px;
}

.button--o {
  color: #FFFFFF;
  font-family: "Exo-2";
  font-size: 16px;
  letter-spacing: 0;
  background-color: #000000;
  padding-left: 47px;
  padding-right: 49px;
  width: 220px;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: 30px;  
}

.button--o svg {
  color: #b20000;
}
</style>

